import { render } from "./Notice.vue?vue&type=template&id=396daa28&scoped=true"
import script from "./Notice.vue?vue&type=script&lang=js"
export * from "./Notice.vue?vue&type=script&lang=js"

import "./Notice.vue?vue&type=style&index=0&id=396daa28&scoped=true&lang=stylus"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396daa28"]])

export default __exports__